export const GENERIC_DOCUMENT_SENT_BACK_APPROVED = "GENERIC_DOCUMENT_SENT_BACK_APPROVED";
export const GENERIC_DOCUMENT_SENT_BACK_SNOOZED = "GENERIC_DOCUMENT_SENT_BACK_SNOOZED";
export const GENERIC_DOCUMENT_SENT_BACK_UPDATED = "GENERIC_DOCUMENT_SENT_BACK_UPDATED";
